import { useEffect, useRef } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isMobile } from "react-device-detect";
import fetchRoute from "../utils/routes";
import { getLocalStorage, setLocalStorage } from "../utils/localStorageUtil";
import { amIImpersonating } from "../utils/apiUtils";
import { getAccountMetaDataService } from "../services/hiddenService";
import { verifyVerisoulAccount } from "../utils/verisoul";
import store from "../store";
import { ACCOUNT_META } from "../const/MetaData";
import { SEGMENT_EVENTS, segmentCondition, segmentPayloads, trackSegmentEvent } from "../const/SegmentEvents";


const GenericWrapper = (props) => {
	const history = useHistory();
	const previousLocation = useRef();
	const previous = useRef();
	useEffect(() => {
		if (isMobile) {
			document.body.className += " mobile";
		}
	}, []);

	useEffect(() => {
		history.listen((location) => {
			const account = store.getState().global?.account;
			const mainPath = location.hash?.split("/")?.[1];
			const prevMainPath = previousLocation.current?.split("/")?.[1];

			if (segmentCondition(SEGMENT_EVENTS.PAGE)) {
				if (previous.current) {
					trackSegmentEvent(
						"$pageleave",
						segmentPayloads(SEGMENT_EVENTS.PAGE, {
							"$current_url": previous.current,
						})
					);
				}
				trackSegmentEvent(
					"$pageview",
					segmentPayloads(SEGMENT_EVENTS.PAGE, {
						path: location.pathname,
						url: window.location.href,
						"$current_url": window.location.href,
						search: window.location.search + location.search,
						referrer: previous.current,
					})
				);
			}

			previous.current = window.location.href;

			if (prevMainPath !== mainPath) {
				fetch("/version.json?bust=" + new Date().getTime()).then((res) => res.json()).then((data) => {
					const version = getLocalStorage("appVersion", "_");
					if (version === null || (version.commitId && version.commitId !== data.commitId)) {
						const newVersion = setLocalStorage("appVersion", data, "_");
						//If setting a fresh version is successfull
						if (newVersion) {
							window.location.reload(true);
						}
					}
				}).catch(() => { });
			}

			let skipAuthSetup = false;

			//1723485970 unix 12/08/2024
			if (account &&
				!`#${fetchRoute("billing")}`.includes(location.hash) &&
				!location.hash.includes("/auth") &&
				!location.hash.includes("/public") &&
				!location.hash.includes("/blockeduser") &&
				!location.hash.includes("/select") &&
				!location.hash.includes("/continueOnDesktop") &&
				account.created_on > 1723485970) {
				verifyVerisoulAccount({ removeCancel: true, action: "recursiveCheck" });
			}


			if (location.hash !== previousLocation.current) {
				if (window?.Appcues) window.Appcues.page();
				previousLocation.current = location.hash;
			}
		});
	}, []);

	return props.children;
};

export default withRouter(
	connect(
		(state) => {
			return {
				segmentDisabledEvent:
					state.brand?.client_config?.segment_config?.disabled_events,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(GenericWrapper)
);
